var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSendHeartBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "62px",
    viewBox: "0 0 62 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icSendHeartBlack") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.0%",
    y: "-18.0%",
    width: "136.0%",
    height: "136.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.2   0 0 0 0 0.2   0 0 0 0 0.2  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-JS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RedHotPie-Platinum-upgrade",
    transform: "translate(-9.000000, -619.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(0.000000, 200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 404.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icSendHeartBlack",
    transform: "translate(15.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "quickMessage",
    transform: "translate(4.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(4.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4844957,3.58763151 C11.5040344,5.70347888 11.5063022,9.10010677 13.4844957,11.2176283 L21.5621458,19.8658765 C21.6414753,19.9514925 21.7518263,20 21.8672667,20 C21.982707,20 22.0930581,19.9514925 22.1723875,19.8658765 C24.8675133,16.9864783 27.5614427,14.1038004 30.2565894,11.2243379 C32.2370508,9.1084541 32.2370508,5.71021205 30.2565894,3.59433038 C28.2761491,1.47845086 25.0387094,1.4784037 23.058248,3.59433038 L21.8705424,4.86041627 L20.6828577,3.58763151 C19.6926165,2.52969068 18.3841097,2 17.0803905,2 C15.7766713,2 14.4747159,2.52968854 13.4844957,3.58763151 Z",
    id: "Combined-Shape",
    fill: "#333333",
    transform: "translate(21.870968, 11.000000) rotate(10.000000) translate(-21.870968, -11.000000) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(7.500000, 10.500000) rotate(90.000000) translate(-7.500000, -10.500000) translate(2.500000, 3.500000)",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,3.5 L1,13.5",
    id: "Line"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,2.5 L5,10.5",
    id: "Line"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,9.66338121e-13 L9,6.5",
    id: "Line"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSendHeartBlack);
export default __webpack_public_path__ + "static/media/icSendHeartBlack.7742653fda128cec9f5cab088d066348.svg";
export { ForwardRef as ReactComponent };